import { render, staticRenderFns } from "./ProgramPageCreate.vue?vue&type=template&id=00c8d914"
import script from "./ProgramPageCreate.vue?vue&type=script&lang=js"
export * from "./ProgramPageCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports